// this file is automatically generated by git.version.ts script
export const versions = { version: '4.0.0', revision: 'aa31451bb', branch: 'DynamicUiPerformance' };
